export default __webpack_public_path__ + "4284f3d0994babf56bd19400b778e71f.svg";